import { report } from "process";
import { globalDexieDb } from "../DexiedbLib";
import { IDBMessage } from "../model/dbMessage";
import { IMessageDetail } from "../model/messageDetails";
import { GetMienCuPhapID } from "../../utils/common";
import { DEBUG } from "../../../../config";

interface GroupItemReport {
    groupName: string;// 2C,3C,4C
    xac: number;
    quaCo: number;
    trung: number;
    thuong: number;
    quaCoHoi: number; // tổng tiền qua cò tham gia tính hồi
    thuongHoi: number; // tổng tiền thưởng tham gia tính hồi
    children: DataItemReport[];
}

interface DataItemReport {
    loaiCuocId: string;
    messageId: number;
    xac: number;
    quaCo: number;
    trung: number;
    thuong: number;
    coHoi: number; // có hồi
    quaCoHoi: number; // tổng tiền qua cò tham gia tính hồi
    thuongHoi: number; // tổng tiền thưởng tham gia tính hồi
}
export interface TotalReportItemNhanChuyen {
    nhanVe: MessageReport;
    chuyenDi: MessageReport;
}
export interface MessageReport {
    contactID: number;
    contactName: string;
    messageId: number;
    body: string;
    date: string;
    time: string;
    type: number;
    tinhId: string;
    viewType: string; // group,details,trace (dò card)
    phanTramThau: number;
    laiLo: number;
    laiLoSauHoi: number;
    tienHoi: number;
    mienDaiCuocId: number;
    mienText: string;
    detailsData: any;
    traceData: any;
    children: GroupItemReport[];
    key: number; // chính là miền 1:MB,2:MT,3:MN
    quaCo: number;
    phanTramHoi: number;
    nguongHoi: number;
    quaCoHoi: number; // tổng tiền qua cò tham gia tính hồi
    thuongHoi: number; // tổng tiền thưởng tham gia tính hồi
    laiLoToanBo: number;// sau khi trừ tiền hồi và nhân 5 khách thầu
    isTotalAllContact?: boolean; // true nếu là tổng hợp tất cả contact
}

export class MessageReportImpl implements MessageReport {
    contactID: number = 0;
    contactName: string = "";
    messageId: number = 0;
    body: string = "";
    date: string = "";
    time: string = "";
    type: number = 0;
    tinhId: string = "";
    viewType: string = "group"; // group,details,trace (dò card)
    phanTramThau: number = 0;
    laiLo: number = 0;
    laiLoSauHoi: number = 0;
    tienHoi: number = 0;
    mienDaiCuocId: number = 0;
    mienText: string = "";
    detailsData: any;
    traceData: any;
    children: GroupItemReport[] = [];
    key: 1 | 2 | 3 | 0 = 0; // chính là miền 1:MB,2:MT,3:MN , nếu lấy cả 3 miền mới điền bình thường =0
    quaCo: number = 0;
    phanTramHoi: number = 0;
    nguongHoi: number = 0;
    quaCoHoi: number = 0; // tổng tiền qua cò tham gia tính hồi
    thuongHoi: number = 0; // tổng tiền thưởng tham gia tính hồi
    laiLoToanBo: number = 0;
    isTotalAllContact?: boolean | undefined = false; // true nếu là tổng hợp tất cả contact

    static loaiCuoc2C: string[] = [
        '6Lo2C', '7Lo2C', '8Lo2C', 'Dau2C', 'Duoi2C', 'Lo2C', 'De', 'DeA', 'Giai1',
        'Giai1A', 'Giai2', 'Giai3', 'Lo', 'LoA', 'LT', 'NC', 'ND', 'NT', 'TC', 'TD',
        'VC', 'VD', 'VN', 'VT',
  ];
    static loaiCuoc3C: string[] = ['6Lo3C', '7Lo3C', 'XC', 'XcDau', 'XcDuoi', 'Lo3C', '3c', '3c1', '3c1A', '3cA']
    static loaiCuoc4C: string[] = ['Dau4C', 'Duoi4C', 'Lo4C']
    static loaiCuocDa: string[] = ['DaT', 'DaX',]
    static loaiCuocXMB: string[] = ['Xi2', 'Xi3', 'Xi4', 'Xi2A', 'Xi3A', 'Xi4A']

    loaiCuocToGroup: Map<string, string> = new Map();
    public dataTotalByLoaiCuoc: Map<string, DataItemReport> = new Map(); // chứa dữ liệu cộng dồn, mỗi loại cược 1 row
    //key = Loại Cược ID
    constructor() {
        this.laiLoToanBo = 0;
        this.quaCoHoi = 0;
        this.thuongHoi = 0;
        this.quaCo = 0;
        this.children = [];
        this.contactID = 0;
        this.contactName = "";
        this.messageId = 0;
        this.body = "";
        this.date = "";
        this.time = "";
        MessageReportImpl.loaiCuoc2C.forEach(key => {
            this.loaiCuocToGroup.set(key, "2C");
        });
        MessageReportImpl.loaiCuoc3C.forEach(key => {
            this.loaiCuocToGroup.set(key, "3C");
        });
        MessageReportImpl.loaiCuoc4C.forEach(key => {
            this.loaiCuocToGroup.set(key, "4C");
        });
        MessageReportImpl.loaiCuocDa.forEach(key => {
            this.loaiCuocToGroup.set(key, "DA");
        });
        MessageReportImpl.loaiCuocXMB.forEach(key => {
            this.loaiCuocToGroup.set(key, "XMB");
        });

    }
    /**
     * cộng thêm dữ liệu chi tiết vào báo cáo dồn lên tổng
     */
    private async addDetailsRow(dataRow: IMessageDetail, minusIfTypeEqual2?: number) {
        let found: DataItemReport | undefined = this.dataTotalByLoaiCuoc.get(dataRow.loaiCuocId)
        if (!found) {
            found = {
                loaiCuocId: dataRow.loaiCuocId,
                messageId: this.messageId,
                xac: 0,
                quaCo: 0,
                trung: 0,
                thuong: 0,
                coHoi: 0,
                quaCoHoi: 0,
                thuongHoi: 0,
            }
            const mienCuPhapId = GetMienCuPhapID()
            const config = await globalDexieDb.contactGiaThuong.where("[mienCuPhapId+mienDaiCuocId+loaiCuocId+contactId]")
                .equals([mienCuPhapId, dataRow.mienDaiCuocId, dataRow.loaiCuocId, this.contactID]).first()
            if (config) {
                found.coHoi = config.hoi || 0
            } else {
                // throw new Error("Không tìm thấy cài đặt hồi trong contactGiaThuong")
                console.error("Không tìm thấy cài đặt hồi trong contactGiaThuong", mienCuPhapId, dataRow.mienDaiCuocId, dataRow.loaiCuocId, this.contactID);
            }
        }
        //cộng dồn
        const quaCo = dataRow.diem! * dataRow.gia! * dataRow.soGiai! * dataRow.heSoNhan
        const thuong = (dataRow.soNhayTrung > 0 ? dataRow.diem! * dataRow.hsThuong * dataRow.soNhayTrung : 0) * dataRow.heSoNhan
        const trung = dataRow.diem! * dataRow.soNhayTrung * dataRow.heSoNhan
        const xac = dataRow.diem! * dataRow.soGiai! * dataRow.heSoNhan
        if (minusIfTypeEqual2 == 2) {// nếu là tin chuyển đi thì trừ số liệu(báo cáo nhận chuyển chung 1 mục)
            found.quaCo -= quaCo
            found.trung -= trung
            found.thuong -= thuong
            found.xac -= xac

        }
        else { // cộng dồn
            found.quaCo += quaCo
            found.trung += trung
            found.thuong += thuong
            found.xac += xac
        }
        if (found.coHoi == 1) {
            if (minusIfTypeEqual2 == 2) {
                found.quaCoHoi -= quaCo
                found.thuongHoi -= thuong
            }
            else {
                found.quaCoHoi += quaCo
                found.thuongHoi += thuong
            }
        }
        this.dataTotalByLoaiCuoc.set(dataRow.loaiCuocId, found)
    }

    private async getReportData(payload: any): Promise<IMessageDetail[]> {
        const { messageId, mienDaiCuocId, ngay, contactId, type } = payload;
        let msgTypeToGet = type != undefined ? type : 0;
        let result: IMessageDetail[] = []
        let messages: IDBMessage[] = []
        if (messageId == 0) {
            messages = await globalDexieDb.dbmessages.where("[date+contactId]")
                .equals([ngay, contactId]).toArray()

        } else {
            messages = await globalDexieDb.dbmessages.where("messageId")
                .equals(messageId).toArray()
        }
        const filterMessage = messages.filter((msg) => {
            if (messageId != 0) {
                this.type = msg.type || 0
            }
            return (msgTypeToGet == 0 || msgTypeToGet == msg.type)
        })
        if (mienDaiCuocId != 0) {
            await Promise.all(filterMessage.map(async (msg) => {
                const data = await globalDexieDb.messageDetails.where("[messageId+mienDaiCuocId]")
                    .equals([msg.messageId!, mienDaiCuocId]).toArray()

                data.map(d => {
                    result.push(d)
                })

                //console.log(msg)
            }))
        } else {
            await Promise.all(filterMessage.map(async (msg) => {
                const data = await globalDexieDb.messageDetails.where("messageId")
                    .equals(msg.messageId!).toArray()

                data.map(d => {
                    result.push(d)
                })

                //console.log(msg)
            }))
        }
        if (DEBUG)
            console.log(result, 'mienDaiCuocId=', mienDaiCuocId, ' getReportData length=', result.length)
        return result;
    }
    private async fillContactInfo(report: MessageReport, payload: any) {
        const { messageId, mienDaiCuocId, ngay, contactId } = payload;
        report.date = ngay;
        report.contactID = contactId;
        //report.key = mienDaiCuocId;
        const contact = await globalDexieDb.contacts.get(contactId)
        if (contact) {
            report.phanTramThau = contact.phanTramThau!;
            report.contactName = contact.name!;
            switch (mienDaiCuocId) {
                case 1:
                    report.phanTramHoi = contact.phanTramMb!;
                    report.nguongHoi = contact.nguongHoiMb!;
                    break;
                case 2:
                    report.phanTramHoi = contact.phanTramMt!;
                    report.nguongHoi = contact.nguongHoiMt!;
                    break;
                case 3:
                    report.phanTramHoi = contact.phanTramMn!;
                    report.nguongHoi = contact.nguongHoiMn!;
                    break;
            }

            if (messageId > 0) {
                const message = await globalDexieDb.dbmessages.where("messageId").equals(messageId).first()
                if (message) {
                    report.body = message.body!
                }
            } else {
                let tenBaoCao = "";
                switch (mienDaiCuocId) {
                    case 1:
                        tenBaoCao = "TỔNG HỢP: MIỀN BẮC"
                        break;
                    case 2:
                        tenBaoCao = "TỔNG HỢP: MIỀN TRUNG"
                        break;
                    case 3:
                        tenBaoCao = "TỔNG HỢP: MIỀN NAM"
                        break;
                }
                report.body = tenBaoCao
            }
        } else {
            console.error("Không tìm thấy contact")
            throw new Error("Không tìm thấy contact")

        }

    }
    private async tinhLaiLo(groupItems: Map<string, GroupItemReport>, report: MessageReport) {
        const phanTramHoi = report.phanTramHoi;
        const nguongHoi = report.nguongHoi;
        let laiLoChuaHoi = 0;
        let laiLoTinhHoi = 0;
        let totalQuaco = 0;
        let totalThuong = 0;
        let totalQuacoHoi = 0;
        let totalThuongHoi = 0;
        let tienHoi = 0;
        for (let [group, item] of groupItems) {
            laiLoChuaHoi += item.quaCo - item.thuong;
            laiLoTinhHoi += item.quaCoHoi - item.thuongHoi;
            totalQuaco += item.quaCo;
            totalThuong += item.thuong;
            totalQuacoHoi += item.quaCoHoi;
            totalThuongHoi += item.thuongHoi;
        }
        //qua cò và lãi cùng dấu, tức là chủ có lãi.-> tính tiền hồi
        if ((totalQuacoHoi < 0 && laiLoTinhHoi < 0 ||
            totalQuacoHoi > 0 && laiLoTinhHoi > 0)
            && (report.nguongHoi == 0 || report.nguongHoi < Math.abs(laiLoTinhHoi))) {
            tienHoi = laiLoTinhHoi / 100 * report.phanTramHoi;
        }
        if (report.phanTramThau > 0) {
            laiLoChuaHoi == laiLoChuaHoi - laiLoChuaHoi / 100 * report.phanTramThau;
        }


        report.laiLo = laiLoChuaHoi;
        report.laiLoSauHoi = laiLoChuaHoi - tienHoi;
        report.tienHoi = tienHoi;
        report.quaCoHoi = totalQuacoHoi;
        report.thuongHoi = totalThuongHoi;
        report.laiLoToanBo = this.laiLoSauHoi - this.laiLoSauHoi / 100 * report.phanTramThau;
    }

    /** payload:{ messageId, mienDaiCuocId, ngay, contactId } */
    public async buildReport(payload: { messageId: number, mienDaiCuocId: number, ngay: string, contactId: number }): Promise<MessageReport> {
        const { messageId, mienDaiCuocId, ngay, contactId } = payload
        const report = this;
        this.messageId = messageId;
        this.contactID = contactId;
        this.date = ngay;
        this.mienDaiCuocId = mienDaiCuocId;
        await this.fillContactInfo(report, payload)
        const detailsData = await this.getReportData(payload)
        for (let item of detailsData) {
            await this.addDetailsRow(item)
        }
        //chứa dữ liệu của các nhóm
        const groupItems: Map<string, GroupItemReport> = new Map() // key = 2C,3C,4C
        for (let [loaicuocId, detailsData] of this.dataTotalByLoaiCuoc) {
            let curGroupName: string = this.loaiCuocToGroup.get(loaicuocId)!
            let curGroupData = groupItems.get(curGroupName)
            if (!curGroupData) {
                curGroupData = {
                    groupName: curGroupName,
                    xac: 0,
                    quaCo: 0,
                    trung: 0,
                    thuong: 0,
                    quaCoHoi: 0,
                    thuongHoi: 0,
                    children: [] as DataItemReport[],
                }
                groupItems.set(curGroupName, curGroupData)
            }
            //cộng dồn data và add vào children
            curGroupData.quaCo += detailsData.quaCo
            curGroupData.trung += detailsData.trung
            curGroupData.thuong += detailsData.thuong
            curGroupData.xac += detailsData.xac
            curGroupData.quaCoHoi += detailsData.quaCoHoi
            curGroupData.thuongHoi += detailsData.thuongHoi
            //add vào children
            curGroupData.children.push(detailsData)
        }


        await this.tinhLaiLo(groupItems, report);
        for (let [_, value] of groupItems) {
            report.children.push(value)
        }
        //console.log(result)
        return this
    }
    public sortByGroupName() {
        this.children.sort((a, b) => {
            if (a.groupName < b.groupName) {
                return -1;
            }
            if (a.groupName > b.groupName) {
                return 1;
            }
            return 0;
        });
        for (let group of this.children) {
            group.children.sort((a, b) => {
                if (a.loaiCuocId < b.loaiCuocId) {
                    return -1;
                }
                if (a.loaiCuocId > b.loaiCuocId) {
                    return 1;
                }
                return 0;
            });
        }
    }
    /*Thêm dữ liệu của từng contact vào báo cáo, mục đích để hiển thị toàn bộ nhận hoặc chuyển
    của tất cả các contact*/
    public async addContactDataToReport(payload: MessageReport) {
        const { messageId, mienDaiCuocId, date } = payload
        this.messageId = messageId;
        this.mienDaiCuocId = mienDaiCuocId;
        this.date = date;
        for (let group of payload.children) {
            this.addGroupAndAllChildren(group)
        }


    }
    public addGroupAndAllChildren(newItem: GroupItemReport) {
        const foundGroup = this.children.find(item => item.groupName == newItem.groupName)
        if (foundGroup) {
            foundGroup.quaCo += newItem.quaCo
            foundGroup.trung += newItem.trung
            foundGroup.thuong += newItem.thuong
            foundGroup.xac += newItem.xac
            foundGroup.quaCoHoi += newItem.quaCoHoi
            foundGroup.thuongHoi += newItem.thuongHoi
            const size = newItem.children.length;
            for (let i = 0; i < size; i++) {
                const item = newItem.children[i];
                const foundChild = foundGroup.children.find(child => child.loaiCuocId == item.loaiCuocId)
                if (foundChild) {
                    if (foundChild.loaiCuocId == 'Lo2C') {
                        console.log(foundChild.loaiCuocId,foundChild.xac,"+",item.xac, '=' )
                    }
                    foundChild.quaCo += item.quaCo
                    foundChild.trung += item.trung
                    foundChild.thuong += item.thuong
                    foundChild.xac += item.xac
                    foundChild.quaCoHoi += item.quaCoHoi
                    foundChild.thuongHoi += item.thuongHoi
                    console.log(foundChild.xac)
                    
                }
                else {
                    foundGroup.children.push(item)
                }
            }
        }
        else {
            this.children.push(newItem)
        }

    }
}

